<template>
  <div
    v-cloak
    :class="`px-2 flex flex-col w-full gap-4 py-4 lg:py-0 lg:flex-row lg:content-between nav-utility-bar-b2b-container nav-utility-bar-b2b-container--${mode}`"
    qaid="nav-utility-bar-b2b-container"
  >
    <div class="nav-utility-bar-b2b-container__toggles flex flex-col lg:flex-row gap-4">
      <slot
        name="toggles"
        v-bind="{toggleConsumerFriendlyMode, toggleAdvancedOrderingMode, isConsumerFriendlyMode, advancedOrderingMode}"
      />
    </div>

    <div
      class="nav-utility-bar-b2b-container__controls flex flex-col justify-end gap-4 lg:justify-between lg:items-center lg:flex-row"
    >
      <slot name="controls" v-bind="{loggedIn, isAccountConsumerToggleAccessEnabled, isConsumerFriendlyMode}" />
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState, mapActions} from 'vuex';
import B2bMiniCart from '@/components/mini-cart/b2b/B2bMiniCart';
import AccountSelector from '@/components/account-selector/AccountSelector';
import VendorSelector from '@/components/vendor-selector/VendorSelector';
import NotificationsNav from '@/components/containers/notifications/NotificationsNav';
import {PdlButton} from '@pedal/pdl-button';
import {PdlIcon} from '@pedal/pdl-icon';
import NavUtilityBarVendorSelector from '@/navigation/components/NavUtilityBarVendorSelector';
import NavUtilityBarControl from '@/navigation/components/NavUtilityBarControl';

import NotificationsDropdown from '@/components/containers/notifications/NotificationsDropdown';

export default {
  name: 'NavUtilityBarB2bContainer',
  /* eslint-disable vue/no-unused-components */
  components: {
    PdlButton,
    PdlIcon,
    AccountSelector,
    VendorSelector,
    B2bMiniCart,
    NavUtilityBarVendorSelector,
    NotificationsNav,
    NotificationsDropdown,
    NavUtilityBarControl,
  },
  computed: {
    ...mapState('backend', ['isConsumerFriendlyMode', 'isAccountConsumerToggleAccessEnabled']),
    ...mapState('advancedOrdering', ['advancedOrderingMode']),
    ...mapState('user', ['loggedIn']),
    mode() {
      if (this.advancedOrderingMode) {
        return 'advanced-ordering';
      }
      return this.isConsumerFriendlyMode ? 'consumer-friendly' : 'default';
    },
  },
  watch: {
    // These two modes cannot be "on" at the same time
    isConsumerFriendlyMode(value) {
      if (value) this.setAdvancedOrderingMode(false);
    },
    advancedOrderingMode(value) {
      if (value) this.setConsumerFriendlyMode(false);
    },
  },
  created() {
    this.fetchNotifications(false);
  },

  methods: {
    ...mapActions('backend', ['toggleConsumerFriendlyMode']),
    ...mapActions('advancedOrdering', ['toggleAdvancedOrderingMode']),
    ...mapMutations('backend', ['setConsumerFriendlyMode']),
    ...mapMutations('advancedOrdering', ['setAdvancedOrderingMode']),
    ...mapActions('notifications', ['fetchNotifications']),
  },
};
</script>

<style scoped lang="scss">
.nav-utility-bar-b2b-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: var(--nav-brands-bg);

  @media (screen(lg)) {
    flex-direction: row;
    justify-content: space-between;
  }

  // Variants -----------------------------------
  &--consumer-friendly {
    --nav-brands-bg: var(--blue-100);
  }

  &--advanced-ordering {
    --nav-brands-bg: var(--red-100);
  }

  // Toggles ------------------------------------
  &__toggles {
    display: flex;
    flex-direction: column;

    @media (screen(lg)) {
      align-items: center;
      flex-direction: row;
    }
  }

  &__toggle {
    &:first-child,
    &:empty {
      margin-top: 0;
    }
  }
}
</style>

<style lang="scss">
// Legacy overrides from _pattern-scroll-list.scss
.nav-utility-bar-b2b-container__scroll-list {
  background-clip: padding-box;
  overflow-y: scroll;
  max-height: 10rem !important;

  @media (screen(lg)) {
    max-height: 16rem !important;
  }
}
</style>
